<script>import { ICON_STROKE_MAP } from "./";
export let size = 24;
</script>
<svg width={size} height={size} stroke-width={ICON_STROKE_MAP[size]} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}><path d="M5.6 9.1C6.8 6.7 9.2 5 12 5C15.9 5 19 8.1 19 12C19 15.9 15.9 19 12 19C8.1 19 5 15.9 5 12M9 9.2H5V5.2" stroke="currentColor"/></svg>